<template>
  <div class="insurancePlanMobile">
    <img src="https://cdn.youjiajk.com/%E4%BF%9D%E9%99%A9-2.png" width="100%" alt="">
    <!-- 服务方案 -->
    <div class="insurance-row2">
      <div class="comTitle">结合互联网平台产品生态及服务场景<br> 为其定制医健保合作方案 <br/>赋能平台服务、获客及转化</div>
      <div class="insurance-row2_item1 mrt37">
        <div class="item-box" style="margin-bottom: 0.38rem;">
          <div class="item_title color3 fwb500 fs24">保险产品合作</div>
          <div class="item_line"></div>
          <div class="item_desc color6 fwb400 fs20">特定保险产品合作<br>  BBC健康服务商城</div>
          <img class="mobile-dot1" src="http://cdn.youjiajk.com/dot.png">
        </div>
      </div>

      <div class="insurance-row2_item1 insurance-row2_item2 mrt37">
        <div class="item-box">
          <div class="item_title">流量运营方案</div>
          <div class="item_line"></div>
          <div class="comflex">
            <div class="item_desc">特定人群服务包<br>精准投放高效获客</div>
          </div>
        </div>
        <div class="item-middle-box">
          <div class="item-middle-box_content">
            <div class="mobile-dot2-box left_dot">
              <img class="mobile-dot2" src="http://cdn.youjiajk.com/dot.png">
            </div>
            <div class="middle-content">
              <p class="fs30 fwb500 text-white">携健康之力</p>
              <p class="fs30 fwb500 text-white">筑共赢未来</p>
            </div>
            <div class="mobile-dot2-box right_dot">
              <img class="mobile-dot3" src="http://cdn.youjiajk.com/dot.png">
            </div>
          </div>
          <img class="neiquan" src="http://cdn.youjiajk.com/neiquan.png" alt="">
          <img class="waiquan" src="http://cdn.youjiajk.com/waiquan.png" alt="">
        </div>
        <div class="item-box">
          <div class="item_title color3 fwb500 fs24">用户运营方案</div>
          <div class="item_line"></div>
          <div class="comflex">

            <div class="item_desc color6 fwb400 fs20">平台专属健康权益<br> 会员健康福利设计</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 三大优势 -->
    <div class="advantage-box">
      <div class="comTitle">三大优势</div>
      <div class="advantage-box_content">
        <div class="advantage-box_item">
          <div class="advantage-item_img">
            <img src="https://cdn.youjiajk.com/1%402x.png" />
          </div>
          <div class="advantage-item_content">
            <div class="item_content_img">
              <img src="https://cdn.youjiajk.com/%E4%B8%93%E5%B1%9E%E5%AE%9A%E5%88%B6.png" alt="">
            </div>
            <div class="item_content_desc1 lh40">专属定制</div>
            <div class="item_content_desc2 lh40">根据平台会员特性<br/>定制专属服务/保险</div>
          </div>
        </div>
        <div class="advantage-box_item">
          <div class="advantage-item_img">
            <img src="https://cdn.youjiajk.com/2%402x.png" />
          </div>
          <div class="advantage-item_content">
            <div class="item_content_img">
              <img src="https://cdn.youjiajk.com/%E5%B9%B3%E5%8F%B0%E8%9E%8D%E5%90%88.png" alt="">
            </div>
            <div class="item_content_desc1 lh40">平台融合</div>
            <div class="item_content_desc2 lh40">将服务融入到平台产品体系与场景中 <br /> 用户无突兀感</div>
          </div>
        </div>
        <div class="advantage-box_item">
          <div class="advantage-item_img">
            <img src="https://cdn.youjiajk.com/3%402x.png" />
          </div>
          <div class="advantage-item_content">
            <div class="item_content_img">
              <img src="https://cdn.youjiajk.com/%E7%81%B5%E6%B4%BB%E5%AF%B9%E6%8E%A5.png" alt="">
            </div>
            <div class="item_content_desc1 lh40">灵活对接</div>
            <div class="item_content_desc2 lh40">按需支持 <br /> APP、小程序、API、SDK、H5对接 </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务合作 -->
    <div class="backgroundGray">
      <div class="shangBaoCustomer-box">
        <div class="comTitle">
          已合作服务50+互联网保险平台、互联网企业客户 <br /> 其中业界头部平台合作多家
        </div>
        <div class="shangBaoCustomer-content">
          <div class="shangBaoCustomer_img1">
            <img src="https://cdn.youjiajk.com/Internet1.png" alt="">
          </div>
          <div class="shangBaoCustomer_img2">
            <img src="../../assets/image/right_img1_mobile.png" alt="">
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    }
  }
</script>

<style scoped lang="less">
  .insurancePlanMobile{
    display: flex;
    flex-direction: column;
  }
  .backgroundGray {
    background: #F7FAFF;
  }

  .insurance-row2 {
    background: #ffffff;
    padding-bottom: 2.6rem;

    .comTitle {
      margin: auto;
      text-align: center;
      padding: 0.8rem 0.5rem;
      color: #333333;
      font-size: 0.4rem;
      line-height: 0.6rem;
      font-weight: 400;
    }

    .insurance-row2_item1 {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.37rem;

      .item-box {
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;

        .item_title {
          line-height: 0.24rem;
          color: #333333;
          font-weight: 500;
          font-size: 0.24rem;
        }

        .item_line {
          width: 0.26rem;
          height: 0.03rem;
          background: #FD8246;
          border-radius: 0.02rem;
          margin: 0.1rem 0;
        }

        .item_desc {
          line-height: 0.36rem;
          color: #666666;
          font-weight: 400;
          font-size: 0.2rem;
        }

        .mobile-dot1 {
          margin-top: 0.32rem;
          width: 0.34rem;
        }
      }
    }

    .insurance-row2_item2 {
      justify-content: space-between;
      padding: 0 0.25rem;
      margin-top: 0.32rem;

      .item-middle-box {
        position: absolute;

        .item-middle-box_content {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50%;
          background: #FD8246;
          box-shadow: 0 0.2rem 0.3rem 0 rgb(253 130 70 / 30%);
          text-align: center;
          position: relative;
          top: 2.2rem;
          left: 2.35rem;
          display: flex;
          /* flex-direction: column; */
          justify-content: center;

          .left_dot {
            position: relative;
            left: -0.7rem;
            top: 0.4rem;

            .mobile-dot2 {
              width: 0.34rem;
            }
          }

          .middle-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;

            .text-white {
              color: #FFFFFF;
              font-weight: 500;
              font-size: 0.3rem;
              line-height: 0.4rem;
            }
          }

          .right_dot {
            position: relative;
            right: -0.6rem;
            top: 0.4rem;


            .mobile-dot3 {
              width: 0.34rem;
            }
          }
        }

        .neiquan {
          position: relative;
          left: 2.1rem;
          top: -1.1rem;
          width: 2.9rem;
          animation: run1 12s linear infinite;
        }

        .waiquan {
          position: relative;
          top: -0.78rem;
          left: -1.37rem;
          width: 3.5rem;
          animation: run2 20s linear infinite;
        }
      }
    }
  }

  .advantage-box {
    background: #031323;
    padding: 0.8rem 0;
    text-align: center;
    margin: auto;
    width: 100%;

    .comTitle {
      margin: auto;
      text-align: center;
      padding: 0.8rem 0.75rem;
      color: #ffffff;
      font-size: 0.4rem;
      line-height: 0.6rem;
      font-weight: 300;
    }

    .advantage-box_content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      // margin-top:50px;
      .advantage-box_item {
        position: relative;

        .advantage-item_img {
          width: 0.96rem;
          height: 2.34rem;
          margin: 0 auto;
          position: absolute;
          left: 50%;
          margin-left: -0.5rem;
          top: -0.5rem;

          img {
            width: 100%;
          }
        }

        .advantage-item_content {
          font-size: 0.22rem;
          color: #666666;
          background: #FFFFFF;
          width: 5.68rem;
          height: 3rem;
          border: 0px solid #e7effd;
          border-radius: 0.04rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-top: 0.8rem;

          .item_content_img {
            width: 0.41rem;
            height: 0.52rem;
            margin: 0 auto;

            img {
              width: 100%;
            }
          }

          .item_content_desc1 {
            margin-top: 0.15rem;
            font-size: 0.24rem;
            color: #333;
          }
          .item_content_desc2 {
            font-size: 0.22rem;
            color: #666;
          }
        }

        &:nth-child(2) {
          margin: 0.9rem 0;
        }
      }
    }
  }

  .shangBaoCustomer-box{
    padding-bottom: 0.8rem;
    .comTitle{
      margin: auto;
      text-align: center;
      padding: 0.8rem 0.75rem;
      color: #333333;
      font-size: 0.4rem;
      line-height: 0.6rem;
      font-weight: 400;
    }
    .shangBaoCustomer-content{
      background:#FFFFFF;
      margin: 0rem 0.55rem;
      border-radius: 0.04rem;
      box-shadow: 0rem 0.2rem 0.3rem 0rem rgb(183 195 214 / 20%);
      .shangBaoCustomer_img1{
        // width:3.79rem;
        // height:3.14rem;
        // margin: 0 auto 0.3rem;
        img{
          width: 100%;
        }
      }
      .shangBaoCustomer_img2{
        padding: 0 0.24rem 0.29rem;
        img{
          width: 100%;
        }
      }
    }
  }

  @keyframes run1 {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @keyframes run2 {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(-360deg);
    }
  }

  .lh40 {
    line-height: 0.4rem;
  }
  .pt55{
    padding-top: 0.55rem;
  }
</style>


// WEBPACK FOOTER //
// src/views/mobile/internetMobile.vue